import { render, staticRenderFns } from "./EntitiesTableModal.vue?vue&type=template&id=64d7dc92&"
import script from "./EntitiesTableModal.vue?vue&type=script&lang=ts&"
export * from "./EntitiesTableModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports